module.exports = __webpack_public_path__ + "static/assets/71e0fd256b8f07d51f01c2d8f342bf88.png";